export default __webpack_public_path__ + "7a494207bbc4b9031eea28ac80f2d92f.svg";